import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["confirmation"]
  static values = { url: String, title: String }

  disconnect() {
    clearTimeout(this.confirmationTimer)
  }

  async share(event) {
    event.preventDefault()

    if (typeof navigator.share === "function") {
      try {
        await navigator.share({ title: this.titleValue, url: this.urlValue })
        return
      } catch (error) {
        if (error.name === "AbortError") return
      }
    }

    try {
      await navigator.clipboard.writeText(this.urlValue)
      this.confirmCopy()
    } catch (_error) {
      window.prompt("Copy this link", this.urlValue)
    }
  }

  confirmCopy() {
    if (!this.hasConfirmationTarget) {
      this.flash("Link copied")
      return
    }

    clearTimeout(this.confirmationTimer)
    this.confirmationTarget.hidden = false
    this.confirmationTimer = setTimeout(() => {
      this.confirmationTarget.hidden = true
    }, 3000)
  }

  flash(message) {
    const toast = document.createElement("div")
    toast.textContent = message
    toast.className = "fixed bottom-6 left-1/2 -translate-x-1/2 bg-warm-gray-900 text-white text-sm font-medium px-4 py-2 rounded-full shadow-lg z-50 opacity-0 transition-opacity duration-150"
    document.body.appendChild(toast)
    requestAnimationFrame(() => toast.classList.replace("opacity-0", "opacity-100"))
    setTimeout(() => {
      toast.classList.replace("opacity-100", "opacity-0")
      toast.addEventListener("transitionend", () => toast.remove(), { once: true })
    }, 1800)
  }
}
